export function formatCurrency(n: number) {
  return `${new Intl.NumberFormat("fr-FR", {
    maximumFractionDigits: 2,
  }).format(n)} €`;
}

export const OuiNonOptions = [
  { label: "Oui", value: true },
  { label: "Non", value: false },
];

export enum PersonneType {
  personnePhysique = "personnePhysique",
  personneMorale = "personneMorale",
  organisationInformelle = "organisationInformelle",
}
